export default __webpack_public_path__ + "static/media/account_filled-gray.7d3f5eb0.svg";